import React from 'react';
import moment from 'moment';

const DetalleActividad = ({
    actividad,
    onClose,
    onEditar,
    onEliminar,
    menuAbierto,
    toggleMenu,
    esFechaVencida
}) => {
    const getEstadoClasses = () => {
        if (actividad?.estado === 'completada') {
            return 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-600/20';
        }
        if (esFechaVencida(actividad?.fecha_programada)) {
            return 'bg-rose-50 text-rose-700 ring-1 ring-rose-600/20';
        }
        return 'bg-amber-50 text-amber-700 ring-1 ring-amber-600/20';
    };

    const getEstadoText = () => {
        if (actividad?.estado === 'completada') return 'Completada';
        if (esFechaVencida(actividad?.fecha_programada)) return 'Vencida';
        return 'Pendiente';
    };

    return (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-xl w-[520px] max-w-full mx-4 shadow-xl overflow-hidden">
                <div className="px-6 py-4 border-b border-slate-200 flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <h2 className="text-lg font-semibold text-slate-900">{actividad?.nombre}</h2>
                        <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${getEstadoClasses()}`}>
                            {getEstadoText()}
                        </span>
                    </div>
                    {actividad?.estado !== 'completada' && (
                        <div className="relative">
                            <button 
                                onClick={toggleMenu}
                                className="p-2 hover:bg-slate-100 rounded-full transition-colors"
                            >
                                <svg className="w-5 h-5 text-slate-500" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                                </svg>
                            </button>
                            {menuAbierto && (
                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg ring-1 ring-slate-900/5 z-10">
                                    <div className="py-1">
                                        <button
                                            onClick={() => onEditar(actividad)}
                                            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
                                        >
                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                            </svg>
                                            Editar
                                        </button>
                                        <button
                                            onClick={() => onEliminar(actividad)}
                                            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                                        >
                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                            Eliminar
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className="p-6 space-y-6">
                    <div className="grid grid-cols-2 gap-6">
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Niño</p>
                            <p className="text-sm text-slate-900">{actividad?.detallesNino.nombre}</p>
                        </div>
                        <div>
                            <p className="text-sm font-medium text-slate-500 mb-1">Fecha Programada</p>
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                <span className="text-sm text-slate-900">
                                    {moment(actividad?.fecha_programada).format('DD/MM/YYYY')}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p className="text-sm font-medium text-slate-500 mb-2">Descripción</p>
                        <p className="text-sm text-slate-700 leading-relaxed">{actividad?.descripcion}</p>
                    </div>

                    {actividad?.estado === 'completada' && actividad?.observaciones && (
                        <div className="p-4 bg-emerald-50 rounded-lg">
                            <p className="text-sm font-medium text-emerald-800 mb-1">Observaciones</p>
                            <p className="text-sm text-emerald-700">{actividad.observaciones}</p>
                        </div>
                    )}
                </div>
                <div className="px-6 py-4 bg-slate-50 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DetalleActividad; 